import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/signature';

function fetchSignatureSuccess(state, action) {
  const { code, message } = action.payload;

  state.fetchSignature = {
    success: true,
    error: false,
    code,
    message,
  };
}

function fetchSignatureError(state, action) {
  const { code, message } = action.payload;
  state.fetchSignature = {
    success: false,
    error: true,
    code,
    message,
  };
}

function validateSignatureSuccess(state, action) {
  const { code, message, accountNumber, createdAt: accountCreationDate } = action.payload;
  state.validateSignature = {
    success: true,
    error: false,
    code,
    message,
    accountNumber,
    accountCreationDate,
  };
}

function validateSignatureError(state, action) {
  const { code, message } = action.payload;
  state.validateSignature = {
    success: false,
    error: true,
    code,
    message,
  };
}

const fetchSignature = createAction('fetchSignature');
const validateSignature = createAction('validateSignature');

const signatureReducer = createSlice({
  name: 'signature',
  initialState,
  reducers: {
    fetchSignatureSuccess,
    fetchSignatureError,
    validateSignatureSuccess,
    validateSignatureError,
  },
});

export const signatureActions = {
  ...signatureReducer.actions,
  fetchSignature,
  validateSignature,
};

export default signatureReducer.reducer;
